import { DatabaseManufacturer, DatabaseOwnerEntry } from "../../Api/Database";
import { useEffect, useState } from "react";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useSession } from "../sessionProvider";
import config from "../../Api/config";
import { toast } from "react-toastify";


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
}));


export default function OwnerAccordion() {

    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    
    const { ownerId } = useSession();
    const [brandData, setBrandData] = useState<DatabaseManufacturer>({
        name: "",
        website_url : "",
        summary :"",
        location:"",
        location_iso:"",
        business_registry_info :"",
        eori:"",
        logo:"",
    });
  
    useEffect(() => {
        config.API.getOwner(ownerId).then(brand => {
            setBrandData({...brand});
        }).catch(error => {
            console.error("Error in get owner API: ", error);
            notifyError("Error in get owner API: " + error);
        });
    }, []);

    const handleChange = () => () => {
      setExpanded(!expanded);
    };

    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"owner_settings"}
            sx={{ width: "100%" , marginTop:"20px", marginBottom:"20px"}}
            id={"owner_settings"}
        >
            <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px" }}
            >
            <Typography sx={{ fontSize: "16px", fontWeight: "550" }}>
                Owner details
            </Typography>
            </MuiAccordionSummary>
            <AccordionDetails>
                {/*<RegisterBrand isOwner />*/}
                <div> 
                 
                <div className="product-details">
                    <h2 className="sub-title">OWNER ID: </h2><p>{ownerId}</p>
                    <h2 className="sub-title">OFFICIAL NAME: </h2><p>{brandData.name}</p>
                    <h2 className="sub-title">OFFICIAL WEBSITE: </h2><a href={brandData.website_url} target="_blank">{brandData.website_url}</a>
                    <h2 className="sub-title">SUMMARY: </h2><p>{brandData.summary}</p>
                    <h2 className="sub-title">LOCATION (COUNTRY): </h2><p>{brandData.location}</p>
                    <h2 className="sub-title">LOCATION ISO: </h2><p>{brandData.location_iso !== "" ? brandData.location_iso : "N/A"}</p>
                    <h2 className="sub-title">BUSINESS REGISTRY INFO: </h2><p>{brandData.business_registry_info  !== "" ?<a href={brandData.business_registry_info} target="_blank"> {brandData.business_registry_info}</a> : "N/A"}</p>
                    <h2 className="sub-title">EORI: </h2><p>{brandData.eori  !== "" ? brandData.eori : "N/A"}</p>
                    <h2 className="sub-title">LOGO: </h2><img src={brandData.logo} alt={brandData.name} height="auto" width="150px"/>
                </div>

                <div style={{marginTop:"10px"}}>
                    <button className="form_btn" onClick={() => {
                        navigate('/edit/owner/' + brandData.id);
                    }}>Edit</button>
                </div>

            </div>
            </AccordionDetails>
        </Accordion>
    )
}